<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ThemeToggle from './ThemeToggle.vue'
import GoogleMeetLogo from '@/components/icons/GoogleMeetLogo.vue'
import ZoomLogo from '@/components/icons/ZoomLogo.vue'

const route = useRoute()

// Which product are we viewing? Defaults to Google Meet for non-product routes.
const isZoom = computed(() => route.path.startsWith('/zoom'))
const to = computed(() => (isZoom.value ? '/zoom' : '/google-meet'))
</script>

<template>
  <header class="header">
    <div class="container header__inner">
      <!-- Brand = the current product's logo, linking to its own page. -->
      <RouterLink
        :to="to"
        class="brand"
        :aria-label="isZoom ? 'Zoom' : 'Google Meet'"
      >
        <ZoomLogo v-if="isZoom" :size="32" with-wordmark />
        <GoogleMeetLogo v-else :size="32" with-wordmark />
      </RouterLink>

      <div class="header__actions">
        <ThemeToggle />
      </div>
    </div>
  </header>
</template>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: color-mix(in srgb, var(--bg) 80%, transparent);
  backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--border);
}
.header__inner {
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}

.brand {
  display: inline-flex;
  align-items: center;
  /* Keep the logo from being squeezed by the actions on small screens. */
  min-width: 0;
}

.header__actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
</style>
